import React from 'react';
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import banner from "../../assets/banner/banner1.jpg";
import g1 from "../../assets/Screenshots/1.jpeg";
import g2 from "../../assets/Screenshots/2.jpeg";
import g3 from "../../assets/Screenshots/3.jpeg";
import g4 from "../../assets/Screenshots/4.jpeg";
import g5 from "../../assets/Screenshots/5.jpeg";
import g6 from "../../assets/Screenshots/6.jpeg";
import g7 from "../../assets/Screenshots/7.jpeg";
import g8 from "../../assets/Screenshots/8.jpeg";
import g9 from "../../assets/Screenshots/9.jpeg";
import g10 from "../../assets/Screenshots/10.jpeg";
import g11 from "../../assets/Screenshots/11.jpeg";
import g12 from "../../assets/Screenshots/12.jpeg";
import g13 from "../../assets/Screenshots/13.jpeg";
import g14 from "../../assets/Screenshots/14.jpeg";
import g15 from "../../assets/Screenshots/15.jpeg";
import g16 from "../../assets/Screenshots/16.jpeg";
import g17 from "../../assets/Screenshots/17.jpeg";
import g18 from "../../assets/Screenshots/18.jpeg";
import g19 from "../../assets/Screenshots/19.jpeg";
import g20 from "../../assets/Screenshots/20.jpeg";
import g21 from "../../assets/Screenshots/21.jpeg";
import g22 from "../../assets/Screenshots/22.jpeg";
import g23 from "../../assets/Screenshots/23.jpeg";
import g24 from "../../assets/Screenshots/24.jpeg";
import g25 from "../../assets/Screenshots/25.jpeg";
import g26 from "../../assets/Screenshots/26.jpeg";
import g27 from "../../assets/Screenshots/27.jpeg";
import g28 from "../../assets/Screenshots/28.jpeg";
import g29 from "../../assets/Screenshots/29.jpeg";
import g30 from "../../assets/Screenshots/30.jpeg";
import g31 from "../../assets/Screenshots/31.jpeg";
import g32 from "../../assets/Screenshots/32.jpeg";
import g33 from "../../assets/Screenshots/33.jpeg";
import g34 from "../../assets/Screenshots/34.jpeg";
import g35 from "../../assets/Screenshots/35.jpeg";
import g36 from "../../assets/Screenshots/36.jpeg";
import g37 from "../../assets/Screenshots/37.jpeg";
import g38 from "../../assets/Screenshots/38.jpeg";
import g39 from "../../assets/Screenshots/39.jpeg";
import g40 from "../../assets/Screenshots/40.jpeg";
import g41 from "../../assets/Screenshots/41.jpeg";
import g42 from "../../assets/Screenshots/42.jpeg";
import g43 from "../../assets/Screenshots/43.jpeg";
import g44 from "../../assets/Screenshots/44.jpeg";
import g45 from "../../assets/Screenshots/45.jpeg";
import g46 from "../../assets/Screenshots/46.jpeg";
import g47 from "../../assets/Screenshots/47.jpeg";
import g48 from "../../assets/Screenshots/48.jpeg";
import g49 from "../../assets/Screenshots/49.jpeg";

// Import images dynamically
const images = [
  g1, g2, g3, g4, g5, g6, g7, g8, g9, g10,
  g11, g12, g13, g14, g15, g16, g17, g18, g19, g20,
  g21, g22, g23, g24, g25, g26, g27, g28, g29, g30,
  g31, g32, g33, g34, g35, g36, g37, g38, g39, g40,
  g41, g42, g43, g44, g45, g46, g47, g48, g49
];


export default function Gallery() {
  return (
    <>
      <section>
                    <div className="image-all-banner">
                        <img src={banner} alt="About Us" className="image-bg-all" />
                        <div className="overlay-all-page">
                            <h2 className="fade-in-text">Gallery</h2>
                        </div>
                    </div>
    
    
                </section>
  
     
    <MDBContainer style={{ marginTop:"60px"}}>
     

      <MDBRow className=""> {/* gx-0 removes horizontal gaps */}
        {images.map((image, index) => (
          <MDBCol lg={3} md={4} sm={6} xs={12} key={index} className='p-1'>
            <Zoom>
              <img
                src={image}
                className='w-100 shadow-1-strong rounded'
                alt={`Gallery Image ${index + 1}`}
                style={{ height: '250px', objectFit: 'cover', margin: '0px' }}
              />
            </Zoom>
          </MDBCol>
        ))}
      </MDBRow>
    </MDBContainer>

    </>
  );
}
